module.exports = __webpack_public_path__ + "img/step1.585e3e68.png";